import { FC, ReactNode } from 'react'
import { composeClasses } from '@/utils/compose-classes'

export interface ModalBodyProps {
  children: ReactNode
  className?: string
}

export const _ModalBody: FC<ModalBodyProps> = ({ children, className }) => {
  return <div className={composeClasses(className, 'p-6')}>{children}</div>
}
